import controller from './billfold.controller';
import templateBase from './templates/billfold.view.html';
import adaptativo from './templates/billfold-adaptativo.view.html';

let BillfoldComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
  if(__env.adaptative){
    return adaptativo;
  } else {
    return templateBase;
  }
}



export default BillfoldComponent;



/** WEBPACK FOOTER **
 ** ./www/components/reports/billfold/billfold.component.js
 **/